import { render, staticRenderFns } from "./saleCardTicheng.vue?vue&type=template&id=ab7fa1c6&scoped=true&"
import script from "./saleCardTicheng.vue?vue&type=script&lang=js&"
export * from "./saleCardTicheng.vue?vue&type=script&lang=js&"
import style0 from "./saleCardTicheng.vue?vue&type=style&index=0&id=ab7fa1c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab7fa1c6",
  null
  
)

export default component.exports